export const EXECUTIVE_CURRENCY_CODE = 'USD'
export const EXECUTIVE_CURRENCY_SYMBOL = '$'

export const EXECUTIVE_CURRENCY_METRIC_IDS = new Set(['influenced-revenue', 'spend'])

const appendCurrencyCode = (formatted) => {
  if (!formatted || formatted === '—') return formatted
  if (/\bUSD\b/i.test(formatted)) return formatted
  return `${formatted} ${EXECUTIVE_CURRENCY_CODE}`
}

/** USD formatting for executive dashboard — e.g. $9.46M USD, $480K USD. */
export function formatExecutiveCurrencyMillions(value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '—'
  return appendCurrencyCode(`${EXECUTIVE_CURRENCY_SYMBOL}${numeric.toFixed(2)}M`)
}

export function formatExecutiveCurrency(value) {
  const numeric = Number(value)
  if (!Number.isFinite(numeric)) return '—'

  const abs = Math.abs(numeric)
  const sign = numeric < 0 ? '-' : ''

  if (abs >= 1_000_000) {
    return appendCurrencyCode(`${sign}${EXECUTIVE_CURRENCY_SYMBOL}${(abs / 1_000_000).toFixed(2)}M`)
  }

  if (abs >= 1_000) {
    const thousands = abs / 1_000
    const formatted = Number.isInteger(thousands)
      ? String(Math.round(thousands))
      : thousands.toFixed(1).replace(/\.0$/, '')
    return appendCurrencyCode(`${sign}${EXECUTIVE_CURRENCY_SYMBOL}${formatted}K`)
  }

  return appendCurrencyCode(`${sign}${EXECUTIVE_CURRENCY_SYMBOL}${Math.round(abs).toLocaleString('en-US')}`)
}

const trimTrailingZeros = (numStr) => {
  const numeric = parseFloat(numStr)
  if (Number.isNaN(numeric)) return numStr
  if (Number.isInteger(numeric)) return String(Math.trunc(numeric))
  return String(numeric)
}

/** Normalizes compact USD labels used in channel mix and similar widgets. */
export function normalizeExecutiveCurrencyLabel(value) {
  if (value == null || value === '') return '—'
  const raw = String(value).trim()

  const millionsMatch = raw.match(/^\$([\d.]+)\s*M(?:\s*USD)?$/i)
  if (millionsMatch) {
    return appendCurrencyCode(`${EXECUTIVE_CURRENCY_SYMBOL}${trimTrailingZeros(millionsMatch[1])}M`)
  }

  const thousandsMatch = raw.match(/^\$([\d.]+)\s*K(?:\s*USD)?$/i)
  if (thousandsMatch) {
    return appendCurrencyCode(`${EXECUTIVE_CURRENCY_SYMBOL}${trimTrailingZeros(thousandsMatch[1])}K`)
  }

  if (raw.startsWith(EXECUTIVE_CURRENCY_SYMBOL)) {
    return appendCurrencyCode(raw.replace(/\s*USD$/i, '').trim())
  }

  return raw
}

export function splitExecutiveCurrencyValue(value) {
  const raw = String(value ?? '').trim()
  const match = raw.match(/^(.+?)\s+(USD)$/i)
  if (!match) {
    return { amount: raw, currencyCode: null }
  }
  return { amount: match[1], currencyCode: match[2].toUpperCase() }
}
